<ng-container *ngIf="haveAccess">
<div class="page-title-area item-bg3" >
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>{{email?.project.name}}</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Project Power Bi Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div class="row align-items-center">
                <div class="col-12">
                    <iframe
                        [src]="this.url"
                        frameborder="0"
                        width="100%"
                        height="900"
                        allowtransparency
                    ></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
</ng-container>
